import { useMemo } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { getWindow } from '@change-corgi/core/window';

import { mapButtonConfigs } from './mapButtonConfigs';
import { usePsfShareAvailableShareActions } from './share';
import type { ShareChannel } from './types';

export type { ShareChannel };

type UseActionItemsResult = ModelHookResult<{
	buttonConfigs: ReadonlyArray<{
		action: () => Promise<boolean>;
		channel: ShareChannel;
		label: TranslationKey;
		successLabel?: TranslationKey;
	}>;
}>;

export function useShareActions(): UseActionItemsResult {
	const availableShareActions = usePsfShareAvailableShareActions();
	const { navigator } = getWindow();
	const canShare = !!navigator.canShare;

	const buttonConfigs = useMemo(() => {
		const configs = mapButtonConfigs(availableShareActions);
		return configs.filter(({ channel }) => {
			if (channel === 'mobileNativeShare' && !canShare) {
				return false;
			}
			return true;
		});
	}, [availableShareActions, canShare]);
	return {
		data: {
			buttonConfigs,
		},
	};
}
